<div class="card">
  <div class="card-body">
    <h5 class="mb-4">Grouped Patients</h5>

    @if (patient.subPatients.length > 0) {
      <table class="table table-bordered">
        <thead class="table-dark">
          <tr>
            <th>Patient ID</th>
            <th>EHR MRN(s)</th>
            <th>First Name</th>
            <th>Last Name</th>
            <th>Other Names</th>
            <th>DOB</th>
            <th>Gender</th>
            <th>EMPI</th>
            <th>SSN</th>
            <th>Phone</th>
            <th>Address</th>
            <th>Insurance Member ID</th>
            <th>Match Type</th>
            <th>Match Key(s)</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          @for (subPatient of patient.subPatients; track subPatient) {
            <tr>
              <td>
                <a routerLink="/capture-admin/patients/{{ subPatient.id }}">
                  {{ subPatient.id }}
                </a>
              </td>
              <td>
                <div class="patient-ehr-mrn">
                  @if (subPatient.ehrInstance) {
                    <span>
                      {{ subPatient.ehrInstance }}:
                    </span>
                  }
                  {{ subPatient.mrn }}
                  @if (!subPatient.ehrInstance) {
                    <div>
                      <small>(no EHR Instance)</small>
                    </div>
                  }
                </div>
                @if (subPatient.otherEhrMrns.length > 0) {
                  <div class="patient-other-ehr-mrns">
                    <label>
                      Other EHR MRNs:
                    </label>
                    @for (otherEhrMrn of subPatient.otherEhrMrns; track otherEhrMrn) {
                      <div class="patient-ehr-mrn">
                        {{ otherEhrMrn.ehr }}: {{ otherEhrMrn.mrn }}
                      </div>
                    }
                  </div>
                }
              </td>
              <td>
                {{ subPatient.firstName }}
              </td>
              <td>
                {{ subPatient.lastName }}
              </td>
              <td>
                @for (alternateName of subPatient.alternateNames; track alternateName) {
                  <span>{{ alternateName }}</span>
                }
                @if (subPatient.alternateNames.length === 0) {
                  <span><app-blank-value-dash /></span>
                }
              </td>
              <td>
                {{ subPatient.dob }}
              </td>
              <td>
                {{ subPatient.gender }}
              </td>
              <td>
                {{ subPatient.empi | blankValueDash }}
              </td>
              <td>
                @if (subPatient.hasSsn) {
                  <app-sensitive-string
                    (valueAccessed)="onSsnAccessed(subPatient.id)"
                    [value]="subPatient.decryptedSsn"
                    [hiddenTextLength]="12"
                    />
                }
                @if (!subPatient.hasSsn) {
                  <span><app-blank-value-dash /></span>
                }
              </td>
              <td>
                @for (phoneNumber of subPatient.phoneNumbers; track phoneNumber) {
                  <div>
                    <app-phone-number [number]="phoneNumber" />
                  </div>
                }
                @if (subPatient.phoneNumbers.length === 0) {
                  <span><app-blank-value-dash /></span>
                }
              </td>
              <td>
                @for (address of subPatient.addresses; track address) {
                  <div>
                    <div>{{ address.line1 }}</div>
                    <div>{{ address.line2 }}</div>
                    <div>{{ address.city }}, {{ address.state }} {{ address.zip }}</div>
                  </div>
                }
                @if (subPatient.addresses.length === 0) {
                  <span><app-blank-value-dash /></span>
                }
              </td>
              <td>
                @for (insuranceIdentifier of subPatient.insuranceIdentifiers; track insuranceIdentifier) {
                  <div>
                    {{ insuranceIdentifier }}
                  </div>
                }
                @if (subPatient.insuranceIdentifiers.length === 0) {
                  <span>
                    <app-blank-value-dash />
                  </span>
                }
              </td>
              <td>
                system
              </td>
              <td>
                @for (match of subPatient.groupingKeyMatches; track match) {
                  <div class="grouping-key-match">
                    <span class="grouping-key-match-kind" [class.grouping-key-match-primary]="match.primary">
                      {{ match.kind }}
                    </span>
                    @if (match.confidence !== 'strong') {
                      <span class="grouping-key-match-confidence">
                        ({{ match.confidence }})
                      </span>
                    }
                    <span class="grouping-key-match-patient-id">
                      to {{ match.matchedPatientIds.join(', ') }}
                    </span>
                  </div>
                }
              </td>
              <td>
                <app-patient-status-and-deactivate-button [patient]="subPatient" />
              </td>
            </tr>
          }
        </tbody>
      </table>
    } @else {
      <p>There are no grouped patients.</p>
    }
  </div>
</div>
